import { z } from 'zod';

/**
 * Schéma de validation pour le formulaire de chapitre
 */
export const chapterFormSchema = z.object({
  title: z.string().min(1, 'Le titre est requis').max(255),
  description: z.string().optional(),
  estimatedHours: z.number().min(0.5, 'Minimum 0.5 heures').optional(),
  statusId: z.string().min(1, 'Le statut est requis'),
  subjectExternalId: z.string().min(1, 'La matière est requise'),
  levelExternalId: z.string().min(1, 'Le niveau est requis'),
  establishmentId: z.string().optional(),
  programConceptIds: z.array(z.string().uuid()).optional(),
});

export type ChapterFormData = z.infer<typeof chapterFormSchema>;
